import {
  BrandCreditAccountsWhereColumn,
  SqlOperator,
  useCreditAccountsTableSummaryLazyQuery,
  useGetCreditAccountsLazyQuery,
} from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/brands/page-loading";
import { CardListCreditAccounts } from "@src/components/modules/credit-account/listing/CardListCreditAccounts";
import { BrandCreditAccountsSummaryModel } from "@src/components/modules/credit-account/listing/models";
import { PageCreditAccountsCtx } from "@src/components/modules/credit-account/listing/PageCreditAccounts";
import { StoreCreditAccounts } from "@src/components/modules/credit-account/listing/StoreCreditAccounts";
import { NavigationBrand } from "@src/components/widgets/AppSubNav/NavigationBrand";
import { getQueryParam } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

function useData(store: StoreCreditAccounts) {
  const [fetchCreditAccountsSummary, { loading: loadingSummary }] =
    useCreditAccountsTableSummaryLazyQuery({
      onCompleted(data) {
        if (!data.brandCreditAccountsSummary) return;
        store.brandCreditAccountsSummary = new BrandCreditAccountsSummaryModel(
          data.brandCreditAccountsSummary,
        );
      },
    });
  const [fetchCreditAccounts, { loading }] = useGetCreditAccountsLazyQuery({
    onCompleted(data) {
      store.fromGetCreditAccountsQuery(data);
    },
  });

  useEffect(() => {
    fetchCreditAccounts({ variables: store.queryParams });
    fetchCreditAccountsSummary({ variables: store.queryParams });
  }, [store.queryParams]);

  return { loading, loadingSummary };
}

export const PageBrandCreditAccounts = observer(
  function PageBrandCreditAccounts() {
    const { query } = useRouter();
    const brandId = getQueryParam("id", query);

    const [store] = useState(() => {
      const s = new StoreCreditAccounts(true);

      s.where.implicitFilters.push({
        column: BrandCreditAccountsWhereColumn.BrandId,
        value: brandId,
        operator: SqlOperator.Eq,
      });

      s.where.filters = s.where.filters.filter(
        (f) => ![BrandCreditAccountsWhereColumn.BrandId].includes(f.column),
      );

      return s;
    });

    const { loading, loadingSummary } = useData(store);

    if (loading) {
      return <PageLoading brandId={brandId} />;
    }

    return (
      <PageCreditAccountsCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            <CardListCreditAccounts
              brandId={parseInt(brandId, 10)}
              isSummaryLoaded={!loadingSummary}
              navigation={<NavigationBrand id={brandId} variant="page" />}
            />
          </div>
        </div>
      </PageCreditAccountsCtx.Provider>
    );
  },
);
